namespace GeniuzPOS.ReportMasterData {
    export interface Report_1316Form {
    }

    export class Report_1316Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1316';
    }
}
